import React from 'react';
import * as Styled from './style';

type Props = {
  data: {
    attorneys: string[];
  };
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  errors: {
    attorneys?: string[];
  };

   setErrors: React.Dispatch<React.SetStateAction<any>>;
    handleChange: (
      e:
        | React.ChangeEvent<HTMLInputElement>
        | React.ChangeEvent<HTMLTextAreaElement>
        | React.ChangeEvent<HTMLSelectElement>
    ) => void;
    handleBlur: (
      e:
        | React.ChangeEvent<HTMLInputElement>
        | React.ChangeEvent<HTMLTextAreaElement>
        | React.ChangeEvent<HTMLSelectElement>
    ) => void;

  handleNext: () => void;
  handleBack: () => void;
};

export default function StepThree({
  data,
  setFormData,
  errors,
  handleNext,
  handleBack,
}: Props) {
  const addAttorney = () => {
    setFormData((prev: any) => ({
      ...prev,
      attorneys: [...prev.attorneys, ''],
    }));
  };

  return (
    <>
      <Styled.Title>Attorneys & Staff</Styled.Title>

      <Styled.Group>
        <Styled.Label>
          Please list the names of each attorney at your firm and provide a short bio for each.
          <Styled.HelperText>
            (If these bios exist on your website already, just let us know and we can use those)
          </Styled.HelperText>
        </Styled.Label>

        {data.attorneys.map((attorney, index) => (
          <Styled.SubGroup key={index}>
            <Styled.Textarea
              value={attorney}
              onChange={(e) => {
                const updated = [...data.attorneys];
                updated[index] = e.target.value;
                setFormData((prev: any) => ({
                  ...prev,
                  attorneys: updated,
                }));
              }}
              placeholder={`Attorney name\nPlease provide a short bio`}
            />
          </Styled.SubGroup>
        ))}

        <Styled.AddButton type="button" onClick={addAttorney}>
          + Add another attorney
        </Styled.AddButton>

        {errors.attorneys && <Styled.Error>{errors.attorneys[0]}</Styled.Error>}
      </Styled.Group>

      <Styled.ButtonGroup>
        <Styled.Button type="button" onClick={handleBack}>Go back</Styled.Button>
        <Styled.Button type="button" onClick={handleNext}>
          Next step: legal services →
        </Styled.Button>
      </Styled.ButtonGroup>
    </>
  );
}
